import { Grid } from "@material-ui/core"
import { CardProcesso } from "../../../../../components/cards/card-processo/card-processo"
import { ProcessosListProps } from "./monitoramento-setores-processos-list-props"
import { memo } from "react"
import { useConfigGeraisStore } from "../../../../../../services/app/stores/config-gerais"
import { numberToGridSize } from "../../../../../../utils/number-to-grid-size"

export const MonitoramentoSetoresProcessosList = memo(({
    processos,
    produtosSetor,
    processosSelecionados,
    setAbrirQrCode,
    setProcessosSelecionados,
    getProcessoProdutoSetorWrapper,
    setores,
    ...props
}: ProcessosListProps) => {
    const qtdeProcessos = useConfigGeraisStore(state => state.config.qtdeProcessos)

    return (
        <>
            {processos.sort((a, b) => a.processoProducao - b.processoProducao).map((processo, index, count) => {

                const produtosProcessos = produtosSetor.filter(produto => produto.processoProducaoAtual === processo.processoProducao)

                const processosqtd = processos?.length ?? 1;


                return (
                    <>
                        <Grid item xs={numberToGridSize(qtdeProcessos)}>
                            <CardProcesso
                                count={count}
                                isMonitoramento
                                pedidos={props.pedidos}
                                getProcessoProdutoSetorWrapper={getProcessoProdutoSetorWrapper}
                                processo={processo}
                                processosqtd={processosqtd}
                                produtosProcessos={produtosProcessos}
                                setAbrirQrCode={setAbrirQrCode}
                                processosSelecionados={processosSelecionados}
                                setProcessosSelecionados={setProcessosSelecionados}
                                setores={setores}
                            />
                        </Grid>
                    </>
                )
            })}
        </>
    )
})